/** Normalize auth destinations to a same-origin path, preserving query/hash. */
export function getSafeAuthRedirect(value, fallback = "/") {
  const normalize = (candidate) => {
    if (typeof candidate !== "string" || !candidate.trim()) return null;
    try {
      const url = new URL(candidate, window.location.origin);
      if (
        !["http:", "https:"].includes(url.protocol) ||
        url.origin !== window.location.origin ||
        url.username ||
        url.password
      ) {
        return null;
      }
      // Avoid returning a network-path reference after URL normalization.
      if (url.pathname.startsWith("//")) return null;
      return url.pathname + url.search + url.hash;
    } catch {
      return null;
    }
  };
  return normalize(value) || normalize(fallback) || "/";
}
